import { compose } from 'ramda';

import { coworkingOfferTypeSelector } from './coworkingOfferTypeSelector';

export const isCoworkingSelector = compose(Boolean, coworkingOfferTypeSelector);
